import { isSameDay, format, isBefore, isSameMonth, isSameYear } from "date-fns/fp";
function formatDateRange(dateFrom, dateTo, options = {}) {
  const { d = "d", m = "MMM", y = "yyyy", sep = " ", join = " - " } = options;
  if (!dateTo || isSameDay(dateTo, dateFrom)) {
    return format(`${d}${sep}${m}${sep}${y}`, dateFrom);
  }
  if (isBefore(dateFrom, dateTo)) {
    return formatDateRange(dateTo, dateFrom, options);
  }
  if (isSameMonth(dateTo, dateFrom)) {
    return `${format(d, dateFrom)}${join}${format(
      `${d}${sep}${m}${sep}${y}`,
      dateTo
    )}`;
  }
  if (isSameYear(dateTo, dateFrom)) {
    return `${format(`${d}${sep}${m}`, dateFrom)}${join}${format(
      `${d}${sep}${m}${sep}${y}`,
      dateTo
    )}`;
  }
  return `${format(`${d}${sep}${m}${sep}${y}`, dateFrom)}${join}${format(
    `${d}${sep}${m}${sep}${y}`,
    dateTo
  )}`;
}
export {
  formatDateRange
};
